import { render, staticRenderFns } from "./StudentDetailsIndex.vue?vue&type=template&id=a9026746"
import script from "./StudentDetailsIndex.vue?vue&type=script&lang=js"
export * from "./StudentDetailsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports